import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    changePasswordVerifyTokenResponse: null,
    changePasswordResponse: null
  },
  getters: {
    CHANGE_PASSWORD_TOKEN_CHECKER_RESPONSE: state =>
      state.changePasswordVerifyTokenResponse,
    CHANGE_PASSWORD_RESPONSE: state => state.changePasswordResponse
  },
  mutations: {
    SET_CHANGE_PASSWORD_VERIFY_TOKEN_RESPONSE: (state, payload) => {
      state.changePasswordVerifyTokenResponse = payload
    },
    SET_CHANGE_PASSWORD_RESPONSE: (state, payload) => {
      state.changePasswordResponse = payload
    }
  },
  actions: {
    VERIFY_CHANGE_PASSWORD_TOKEN: async (context, payload) => {
      try {
        const response = await Axios.post(
          '/pub/validate-password-token',
          payload
        )
        context.commit(
          'SET_CHANGE_PASSWORD_VERIFY_TOKEN_RESPONSE',
          response.data
        )
      } catch (error) {
        context.commit(
          'SET_CHANGE_PASSWORD_VERIFY_TOKEN_RESPONSE',
          error.response.data
        )
      }
    },
    CHANGE_PASSWORD: async (context, payload) => {
      try {
        const response = await Axios.post('/pub/change-password', payload)
        context.commit('SET_CHANGE_PASSWORD_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_CHANGE_PASSWORD_RESPONSE', error.response.data)
      }
    }
  }
}
